





import { defineComponent } from 'vue';

export default defineComponent({
  name: 'WordHighlight',
  props: {
    index: { type: Number, required: true },
    text: { type: String, required: true },
  },
});
